import React from "react";
import { CoachClientTagsListRoute } from "../../../../components/coach-clients-tags/CoachClientsTagsListScreen";

export const CoachClientsTagsRoute = () => {
  return <CoachClientTagsListRoute />;
};
